import React from 'react';
import { Router } from '@/modules/Router';
import { useSessionRefresh } from '@/modules/Auth';
import { useGetLocales } from '@/modules/Locales';
import GlobalStyles from './styles/global';

class ErrorBoundary extends React.Component<React.PropsWithChildren, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <p>Something went wrong.</p>;
    }

    return this.props.children;
  }
}

const App = () => {
  useSessionRefresh();
  useGetLocales();

  return (
    <ErrorBoundary>
      <div className="App">
        <GlobalStyles />
        <Router />
      </div>
    </ErrorBoundary>
  );
};

export default App;
